import clsx from 'clsx'

import s from './SegmentedControl.module.css'

interface SegmentedControlProps<T extends string> {
  options: ReadonlyArray<{ value: T; label: string }>
  value: T
  onChange: (value: T) => void
  'aria-label'?: string
}

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ...rest
}: SegmentedControlProps<T>) {
  return (
    <div className={s.seg} role="group" aria-label={rest['aria-label']}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={clsx(s.item, option.value === value && s.active)}
          onClick={() => onChange(option.value)}
          aria-pressed={option.value === value}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
